export default {"src":"/_next/static/media/rainbow-purple-to-blue-right.6d8d8d67.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};